import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const TASK_TYPES_CONFIG = {
  simple_validation: {
    labelKey: "Validation simple",
    borderColor: "arh-border-btnGreen",
    bgColor: "arh-bg-cardGreen",
    textColor: "arh-text-btnGreen"
  },
  document_sending: {
    labelKey: "Envoi de document",
    borderColor: "arh-border-[#738BC7]",
    bgColor: "arh-bg-[#E6EBF8]",
    textColor: "arh-text-[#738BC7]"
  },
  upload_request: {
    labelKey: "Demande de téléversement",
    borderColor: "arh-border-[#FA966B]",
    bgColor: "arh-bg-[#F8EAE4]",
    textColor: "arh-text-[#FA966B]"
  },
  signature_request: {
    labelKey: "Demande de signature",
    borderColor: "arh-border-[#61C2E0]",
    bgColor: "arh-bg-[#D8F5FB]",
    textColor: "arh-text-[#61C2E0]"
  },
  electronic_signature: {
    labelKey: "Signature electronique",
    borderColor: "border-[#AA4299]",
    bgColor: "arh-bg-[#F8E6F5]",
    textColor: "arh-text-[#AA4299]"
  },
  answer: {
    labelKey: "Réponse",
    borderColor: "arh-border-[#E4B334]",
    bgColor: "arh-bg-[#FAEFDC]",
    textColor: "arh-text-[#E4B334]"
  },
  request_job: {
    labelKey: "Demande de recrutement",
    borderColor: "arh-border-btnViolet",
    bgColor: "arh-bg-cardViolet",
    textColor: "arh-text-btnViolet"
  }
};

export default function TaskExpectedResult({ type }) {
  const { t } = useTranslation("beginEnd.protocol");
  
  const config = useMemo(() => TASK_TYPES_CONFIG[type], [type]);
  
  if (!config) return null;
  
  const baseClasses = "arh-m-0 arh-w-fit arh-rounded arh-border arh-border-solid arh-p-1.5 arh-text-center arh-font-poppins arh-text-fontBodyTable arh-font-semibold arh-normal-case";
  
  return (
    <label className={`${baseClasses} ${config.borderColor} ${config.bgColor} ${config.textColor}`}>
      {t(config.labelKey)}
    </label>
  );
}